// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"b24768c2","707":"381f8b96","729":"f9342683"}[chunkId] + ".js";
};